declare namespace $ {

	type __shm_showcase_demo_check_list_1 = $mol_type_enforce<
		Parameters< $shm_showcase_demo_check_list['selected'] >[0]
		,
		Parameters< ReturnType< $shm_showcase_demo_check_list['Input'] >['value'] >[0]
	>
	type $shm_check_list__options_shm_showcase_demo_check_list_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_check_list['options'] >
	>
	type $mol_text__text_shm_showcase_demo_check_list_3 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_check_list['summary'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_showcase_demo_check_list extends $mol_list {
		selected( next?: ReturnType< ReturnType< $shm_showcase_demo_check_list['Input'] >['value'] > ): ReturnType< ReturnType< $shm_showcase_demo_check_list['Input'] >['value'] >
		Input( ): $shm_check_list
		summary( ): string
		Selected( ): $mol_text
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map